import dynamic from "next/dynamic";
import useSWR from "swr";

import { useState } from "react";

import { twMerge } from "tailwind-merge";

import { entityCorporateOfficersUrl } from "components/EntityPageLayout/EntityPageInvestorRelations";
import useSignInSignUp from "components/SignInSignUpModal/useSignInSignUp";
import useAuthentication from "hooks/useAuthentication";
import { baseFetcher } from "utils/baseFetcher";

const ContactIRModal = dynamic(() => import("components/ContactIRModal"));

const ContactIRButton = ({ slug }: { slug: string }) => {
  const { toggleModal } = useSignInSignUp();
  const { authenticated } = useAuthentication();
  const [showContactIRModal, toggleContactIRModal] = useState(false);

  const { data } = useSWR(entityCorporateOfficersUrl(slug, 1), baseFetcher);

  if (!data?.data?.length) return <></>;

  return (
    <>
      <button
        className={twMerge(
          "border border-solid border-smart-teal bg-white",
          "rounded-full px-[23px] py-[5px]",
          "text-[16px] text-smart-teal font-medium"
        )}
        onClick={() =>
          authenticated
            ? toggleContactIRModal(!showContactIRModal)
            : toggleModal("sign-in")
        }
      >
        Contact IR
      </button>
      {showContactIRModal && (
        <ContactIRModal
          profiles={data?.data}
          onClose={() => {
            toggleContactIRModal(!showContactIRModal);
          }}
        />
      )}
    </>
  );
};

export default ContactIRButton;
